export const DELIMITER = '\n';
export const MEASURE_DELAY = 100;
export const EDITOR_SUBMIT = 'editor-submit';
export const HANDLED = 'handled';
export const NOT_HANDLED = 'not-handled';

export const TOOLBAR_STYLE_KEYS = ['toolbar'];
export const TOOLBAR_BUTTON_STYLE_KEYS = ['buttonWrapper', 'button', 'active'];
export const MENTIONS_STYLE_KEYS = [
  'mention',
  'mentionSuggestions',
  'mentionSuggestionsEntry',
  'mentionSuggestionsEntryFocused',
  'mentionSuggestionsEntryText',
];

export const LINK_ENTITY_NAME = 'LINK';
